"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import { createBreakpoint } from "react-use";
import { useContentTab } from "@/components/brain/ContentTabContext";
import MemesArtSubmissionModal from "@/components/waves/memes/MemesArtSubmissionModal";
import type { ApiWave } from "@/generated/models/ApiWave";
import MyStreamWaveDesktopTabs from "../MyStreamWaveDesktopTabs";
import MyStreamWaveCreateCurationAction from "./MyStreamWaveCreateCurationAction";
import MyStreamWaveTabsHeader, { type MyStreamWaveTabsHeaderActionContext } from "./MyStreamWaveTabsHeader";
import MyStreamWaveTabsMemeSubmit from "./MyStreamWaveTabsMemeSubmit";
const useBreakpoint = createBreakpoint({
  LG: 1024,
  MD: 768,
  S: 0
});
interface MyStreamWaveTabsMemeProps {
  readonly wave: ApiWave;
  readonly activeCurationId: string | null;
  readonly onSelectCuration: (curationId: string | null) => void;
}
const MyStreamWaveTabsMeme: React.FC<MyStreamWaveTabsMemeProps> = t0 => {
  const $ = _c(36);
  const {
    wave,
    activeCurationId,
    onSelectCuration
  } = t0;
  const {
    activeContentTab,
    setActiveContentTab
  } = useContentTab();
  const [isMemesModalOpen, setIsMemesModalOpen] = useState(false);
  const breakpoint = useBreakpoint();
  const isCompact = breakpoint === "S";
  const showExternalCreateCurationAction = breakpoint === "LG";
  const showBackButton = breakpoint !== "LG";
  const headerActionsTooltipId = `my-stream-wave-meme-header-actions-${wave.id}`;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setIsMemesModalOpen(true);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleMemesSubmit = t1;
  let t2;
  if ($[1] !== wave) {
    t2 = t3 => {
      const {
        isCompact: headerIsCompact
      } = t3;
      return headerIsCompact ? null : <MyStreamWaveTabsMemeSubmit handleMemesSubmit={handleMemesSubmit} wave={wave} />;
    };
    $[1] = wave;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const renderHeaderLeadingActions = t2;
  let t3;
  if ($[3] !== activeContentTab || $[4] !== headerActionsTooltipId || $[5] !== isCompact || $[6] !== onSelectCuration || $[7] !== renderHeaderLeadingActions || $[8] !== setActiveContentTab || $[9] !== showBackButton || $[10] !== wave) {
    t3 = <MyStreamWaveTabsHeader wave={wave} activeContentTab={activeContentTab} setActiveContentTab={setActiveContentTab} onSelectCuration={onSelectCuration} isCompact={isCompact} showBackButton={showBackButton} headerActionsTooltipId={headerActionsTooltipId} headerClassName="tw-flex tw-items-center tw-justify-between tw-gap-x-4 md:tw-gap-x-8 tw-overflow-x-hidden tw-px-2 tw-py-3 sm:tw-px-4" actionsClassName="tw-flex tw-flex-shrink-0 tw-items-center tw-gap-x-2 md:tw-shrink-0" rightSidebarButtonBackgroundClassName="tw-bg-iron-700" renderLeadingActions={renderHeaderLeadingActions} />;
    $[3] = activeContentTab;
    $[4] = headerActionsTooltipId;
    $[5] = isCompact;
    $[6] = onSelectCuration;
    $[7] = renderHeaderLeadingActions;
    $[8] = setActiveContentTab;
    $[9] = showBackButton;
    $[10] = wave;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const t4 = !showExternalCreateCurationAction;
  let t5;
  if ($[12] !== activeContentTab || $[13] !== activeCurationId || $[14] !== onSelectCuration || $[15] !== setActiveContentTab || $[16] !== t4 || $[17] !== wave) {
    t5 = <div className="tw-min-w-0 tw-flex-1"><MyStreamWaveDesktopTabs activeTab={activeContentTab} wave={wave} setActiveTab={setActiveContentTab} activeCurationId={activeCurationId} onSelectCuration={onSelectCuration} showCreateCurationAction={t4} /></div>;
    $[12] = activeContentTab;
    $[13] = activeCurationId;
    $[14] = onSelectCuration;
    $[15] = setActiveContentTab;
    $[16] = t4;
    $[17] = wave;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== onSelectCuration || $[20] !== showExternalCreateCurationAction || $[21] !== wave) {
    t6 = showExternalCreateCurationAction && <MyStreamWaveCreateCurationAction wave={wave} onCreated={onSelectCuration} />;
    $[19] = onSelectCuration;
    $[20] = showExternalCreateCurationAction;
    $[21] = wave;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  let t7;
  if ($[23] !== t5 || $[24] !== t6) {
    t7 = <div className="tw-flex tw-items-center tw-justify-between tw-gap-4 tw-border-x-0 tw-border-y tw-border-solid tw-border-iron-800">{t5}{t6}</div>;
    $[23] = t5;
    $[24] = t6;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  let t8;
  if ($[26] !== t3 || $[27] !== t7) {
    t8 = <div className="tw-flex tw-w-full tw-flex-col tw-bg-iron-950">{t3}{t7}</div>;
    $[26] = t3;
    $[27] = t7;
    $[28] = t8;
  } else {
    t8 = $[28];
  }
  let t9;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => setIsMemesModalOpen(false);
    $[29] = t9;
  } else {
    t9 = $[29];
  }
  let t10;
  if ($[30] !== isMemesModalOpen || $[31] !== wave) {
    t10 = <MemesArtSubmissionModal isOpen={isMemesModalOpen} wave={wave} onClose={t9} />;
    $[30] = isMemesModalOpen;
    $[31] = wave;
    $[32] = t10;
  } else {
    t10 = $[32];
  }
  let t11;
  if ($[33] !== t10 || $[34] !== t8) {
    t11 = <>{t8}{t10}</>;
    $[33] = t10;
    $[34] = t8;
    $[35] = t11;
  } else {
    t11 = $[35];
  }
  return t11;
};
export default MyStreamWaveTabsMeme;